<template>
    <div class="financiamiento-view">
        <ComingSoon
            :label="sectionContent.label"
            :description="sectionContent.description"
        />
    </div>
</template>

<script>
import ComingSoon from "@/components/layout/ComingSoon.vue";

// Cada section maneja su propio label + description. Bancos y Factoring son
// secciones independientes (no sub-tabs) según navConfig.js — leemos
// $route.query.section para saber cuál renderizar.
const SECTION_CONTENT = Object.freeze({
    bancos: {
        label: "Bancos",
        description:
            "En esta sección podrás conectar con distintos bancos para obtener financiamiento.",
    },
    factoring: {
        label: "Factoring",
        description:
            "En esta sección podrás conectar con distintos factoring para obtener financiamiento.",
    },
});

const DEFAULT_CONTENT = Object.freeze({
    label: "Financiamiento",
    description: "Esta sección está en construcción. Estará disponible próximamente.",
});

export default {
    name: "Financiamiento",
    components: {
        ComingSoon,
    },
    computed: {
        sectionContent() {
            const section = this.$route.query.section;
            return SECTION_CONTENT[section] || DEFAULT_CONTENT;
        },
    },
};
</script>

<style lang="scss" scoped>
.financiamiento-view {
    padding: 16px;
}
</style>
